"use strict";

/**
 * @classdesc
 * Abstrakte Geometrie-Bearbeiten-Interaktion.
 *
 * @class
 * @memberof gc.gis.module.GCEditGeometry
 * @author Christian Schmdidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCEditGeometry} options.instance Modul-Instanz
 * @param {gc.gis.map.GCMapView} options.map Karten-Instanz
 */
gc.gis.module.GCEditGeometry.Impl = function( options )
{
	gc.gis.GCObservable.call(this);

	this.module = options.instance;
	this.map    = options.map;

	this._cancelAction = new gc.gis.action.editgeometry.cancel(this.module, this);
	this._saveAction = new gc.gis.action.editgeometry.save(this.module);
	this._deleteAction = new gc.gis.action.editgeometry.delete(this.module);
	this._clearDrawingAreaAction = new gc.gis.action.editgeometry.clearDrawArea(this.module, this);

	/**
	 * Interaktion zum Bearbeiten
	 * @var gc.gis.map.GCMapTransformInteraction
	 */
	this._transform_interaction = gc.gis.iface.mapFactory.createMapTransformInteraction(this.map, {
		hoverStyle: gc.gis.iface.styleFactory.getStyleFunction(gc.gis.factory.StyleType.SELECTABLE),
		selectStyle: gc.gis.iface.styleFactory.getStyleFunction(gc.gis.factory.StyleType.SELECTED),
		allowClearDrawingArea: true,
		clearDrawingAreaAction: this._clearDrawingAreaAction,
		toolbarButtons: gc.gis.map.GCMapTransformInteractionButtons.SAVE
			| gc.gis.map.GCMapTransformInteractionButtons.DELETE
			| gc.gis.map.GCMapTransformInteractionButtons.CANCEL,
		saveAction: this._saveAction,
		deleteAction: this._deleteAction,
		cancelAction: this._cancelAction
	});
	this._transform_interaction.setActive(false);
};
gc.gis.module.GCEditGeometry.Impl.prototype = Object.create(gc.gis.GCObservable.prototype);

/**
 * Liefert die zugrundeliegende Transform-Interaktion.
 *
 * @public
 * @method
 *
 * @return {gc.gis.map.GCMapTransformInteraction}
 */
gc.gis.module.GCEditGeometry.Impl.prototype.getTransformInteraction = function ()
{
	return this._transform_interaction;
};

/**
 * Liefert die durch den Nutzer selektierten Features.
 *
 * @public
 * @method
 *
 * @return {gc.gis.feature.GCFeature[]}
 */
gc.gis.module.GCEditGeometry.Impl.prototype.getSelectedFeatures  = function()
{
	return this._transform_interaction.getSelectedFeatures()
};

/**
 * Liefert die Anzahl der durch den Nutzer geänderten Features.
 *
 * @public
 * @method
 *
 * @return {gc.gis.feature.GCFeature[]}
 */
gc.gis.module.GCEditGeometry.Impl.prototype.numChangedFeatures = function ()
{
	return this._transform_interaction.numChangedFeatures();
};

/**
 * Liefert die durch den Nutzer geänderten Features.
 *
 * @public
 * @method
 *
 * @return {gc.gis.feature.GCFeature[]}
 */
gc.gis.module.GCEditGeometry.Impl.prototype.getChangedFeatures  = function()
{
	return this._transform_interaction.getChangedFeatures();
};

/**
 * Zeigt an, ob die Bearbeitungsfunktion aktiv bzw. deaktiv ist.
 *
 * @public
 * @method
 *
 * @return {boolean}
 */
gc.gis.module.GCEditGeometry.Impl.prototype.isEditEnabled = function()
{
	return this._transform_interaction.isActive();
};

/**
 * Setzt die Bearbeitungsfunktion aktiv bzw. deaktiv.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {boolean} active
 */
gc.gis.module.GCEditGeometry.Impl.prototype.enableEdit = gc.gis.abstractMethod;

/**
 * Setzt den Layer, welcher bearbeitet werden soll.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {gc.gis.layer.GCLayer} layer
 */
gc.gis.module.GCEditGeometry.Impl.prototype.setEditLayer = gc.gis.abstractMethod;

/**
 * Überführt eine Menge von geänderten Features in Features, welche über den FeatureTransactionService transportiert
 * werden können.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {gc.gis.feature.GCFeature[]} features
 * @param {boolean} ids_only
 * @return {gc.gis.service.feature.AbstractTransactionFeature[]}
 */
gc.gis.module.GCEditGeometry.Impl.prototype.toTransactionServiceFeatures = gc.gis.abstractMethod;

/**
 * Hook-Methode die aufgerufen wird, wenn der Nutzer die Bearbeitung für eine Menge von Features abbricht.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {gc.gis.feature.GCFeature[]} features
 */
gc.gis.module.GCEditGeometry.Impl.prototype.editCancel = gc.gis.abstractMethod;

/**
 * Hook-Methode die aufgerufen wird, wenn eine Menge von Features erfolgreich gespeichert wurde.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {gc.gis.feature.GCFeature[]} features
 */
gc.gis.module.GCEditGeometry.Impl.prototype.saveSuccess = gc.gis.abstractMethod;

/**
 * Hook-Methode die aufgerufen wird, wenn eine Menge von Features nicht erfolgreich gespeichert wurde.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {gc.gis.feature.GCFeature[]} features
 */
gc.gis.module.GCEditGeometry.Impl.prototype.saveFailed = gc.gis.abstractMethod;

/**
 * Hook-Methode die aufgerufen wird, wenn eine Menge von Features erfolgreich gelöscht wurde.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {gc.gis.feature.GCFeature[]} features
 */
gc.gis.module.GCEditGeometry.Impl.prototype.deleteSuccess = gc.gis.abstractMethod;

/**
 * Hook-Methode die aufgerufen wird, wenn eine Menge von Features nicht erfolgreich gelöscht wurde.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {gc.gis.feature.GCFeature[]} features
 */
gc.gis.module.GCEditGeometry.Impl.prototype.deleteFailed = gc.gis.abstractMethod;